"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[911],{

/***/ 91922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CharacterLimitIndicator; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95576);






function CharacterLimitIndicator(_param) {
    var description = _param.description, maxLength = _param.maxLength, css = _param.css, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "description",
        "maxLength",
        "css"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("span", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        css: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, css), {
            color: description.length > maxLength ? _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .red */ .Q6 : _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .sealBlue */ .N9,
            fontSize: 12,
            userSelect: "none"
        }),
        children: [
            description.length,
            "/",
            maxLength
        ]
    }));
};


/***/ }),

/***/ 23158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HighlightsInputField; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-final-form@6.5.9_s44h3cxpdxv6cks4bnqewerqda/node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(56225);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(49980);
// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-powerplug@1.0.0_react@17.0.2/node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(41491);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
;// CONCATENATED MODULE: ./components/form/HighlightsInput.tsx










function HighlightsInput(_param) {
    var value = _param.value, onChange = _param.onChange, maxItems = _param.maxItems, characterLimit = _param.characterLimit, bulletColor = _param.bulletColor, inputBorderColor = _param.inputBorderColor, props = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onChange",
        "maxItems",
        "characterLimit",
        "bulletColor",
        "inputBorderColor"
    ]);
    var intl = (0,useIntl/* default */.Z)();
    var addInputRef = /*#__PURE__*/ (0,react.createRef)();
    var highlightRefs = value.map(function() {
        return /*#__PURE__*/ (0,react.createRef)();
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        css: {
            height: "100%",
            backgroundColor: "rgba(37, 192, 136, 0.05)",
            padding: 15
        }
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
            css: {
                listStyle: "none",
                margin: 0,
                padding: 0
            },
            children: [
                value.map(function(highlight, index) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                        css: {
                            display: "flex",
                            alignItems: "center",
                            "&:not(:first-of-type)": {
                                marginTop: 10
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    marginRight: 10,
                                    display: "inline"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        width: 13,
                                        textAlign: "center"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightBullet, {
                                        color: bulletColor
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                ref: highlightRefs[index],
                                maxLength: characterLimit,
                                placeholder: highlight === "" ? intl.formatMessage({
                                    defaultMessage: "Press Backspace to remove",
                                    id: "s48Fto"
                                }) : intl.formatMessage({
                                    defaultMessage: "Type another highlight...",
                                    id: "7P342p"
                                }),
                                css: {
                                    backgroundColor: palette/* white */.ix,
                                    border: "solid 1px ".concat(palette/* lightestGray */.v2),
                                    fontSize: 14,
                                    height: 48,
                                    paddingLeft: 20,
                                    paddingRight: 20,
                                    letterSpacing: 0.5,
                                    color: palette/* mediumGray */.rF,
                                    lineHeight: 1.14,
                                    width: "95%",
                                    outline: "none",
                                    borderRadius: 4,
                                    "&:focus": {
                                        border: "solid 1px ".concat(inputBorderColor || palette/* greenSuccess */.CU)
                                    }
                                },
                                value: highlight,
                                onChange: function(e) {
                                    onChange(value.map(function(value, maybeIndex) {
                                        return index === maybeIndex ? e.target.value : value;
                                    }));
                                },
                                onKeyDown: function(e) {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        if (e.currentTarget.value !== "" && addInputRef.current) {
                                            addInputRef.current.focus();
                                        }
                                    }
                                    if (e.key === "Backspace" && e.currentTarget.value === "") {
                                        e.preventDefault();
                                        var nextItems = value.filter(function(_, maybeIndex) {
                                            return maybeIndex !== index;
                                        });
                                        onChange(nextItems);
                                        if (nextItems.length === 0 && addInputRef.current) {
                                            addInputRef.current.focus();
                                        }
                                        if (highlightRefs[index - 1] && highlightRefs[index - 1].current !== null) {
                                            highlightRefs[index - 1].current.focus();
                                        }
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                ml: 10,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        width: 30,
                                        textAlign: "left"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CharacterCount, {
                                        children: characterLimit - highlight.length
                                    })
                                })
                            })
                        ]
                    }, index);
                }),
                value.length < maxItems && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                    initial: "",
                    children: function(param) {
                        var highlight = param.value, setValue = param.set;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                            css: {
                                display: "flex",
                                alignItems: "center",
                                "&:not(:first-of-type)": {
                                    marginTop: 10
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        display: "inline",
                                        marginRight: 10
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            width: 13,
                                            height: 13,
                                            textAlign: "center",
                                            color: palette/* sealBlue */.N9,
                                            fontSize: 13,
                                            cursor: "pointer"
                                        },
                                        role: "button",
                                        "aria-label": "Add highlight",
                                        onClick: function(event) {
                                            event.preventDefault();
                                            if (highlight.trim() !== "") {
                                                setValue("");
                                                onChange((0,_to_consumable_array/* default */.Z)(value).concat([
                                                    highlight.trim()
                                                ]));
                                            }
                                            if (addInputRef.current) {
                                                addInputRef.current.focus();
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                                            width: 15,
                                            height: 15,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                d: "M13.929 6.429H8.57V1.07a1.072 1.072 0 0 0-2.142 0V6.43H1.07a1.072 1.072 0 0 0 0 2.142H6.43v5.358a1.072 1.072 0 0 0 2.142 0V8.57h5.358a1.072 1.072 0 0 0 0-2.142z",
                                                fill: "currentColor",
                                                fillRule: "nonzero"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                    ref: addInputRef,
                                    maxLength: characterLimit,
                                    placeholder: intl.formatMessage({
                                        defaultMessage: "Type another highlight...",
                                        id: "7P342p"
                                    }),
                                    css: {
                                        backgroundColor: palette/* white */.ix,
                                        border: "solid 1px ".concat(palette/* lightestGray */.v2),
                                        fontSize: 14,
                                        height: 48,
                                        paddingLeft: 20,
                                        paddingRight: 20,
                                        letterSpacing: 0.5,
                                        color: palette/* mediumGray */.rF,
                                        lineHeight: 1.14,
                                        width: "95%",
                                        outline: "none",
                                        borderRadius: 4,
                                        "&:focus": {
                                            border: "solid 1px ".concat(inputBorderColor || palette/* greenSuccess */.CU)
                                        }
                                    },
                                    value: highlight,
                                    onChange: function(e) {
                                        return setValue(e.target.value);
                                    },
                                    onKeyDown: function(e) {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            if (highlight.trim() !== "") {
                                                setValue("");
                                                onChange((0,_to_consumable_array/* default */.Z)(value).concat([
                                                    highlight.trim()
                                                ]));
                                            }
                                        } else if (e.key === "Backspace" && highlight.trim() === "" && highlightRefs.length > 1) {
                                            highlightRefs[highlightRefs.length - 1].current.focus();
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    ml: 10,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            width: 30,
                                            textAlign: "left"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CharacterCount, {
                                            children: characterLimit - highlight.length
                                        })
                                    })
                                })
                            ]
                        });
                    }
                })
            ]
        })
    }));
};
function CharacterCount(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,_object_spread/* default */.Z)({
        css: {
            fontSize: 14,
            lineHeight: 1.71,
            color: palette/* sealBlue */.N9,
            marginLeft: "auto"
        }
    }, props));
}
var HighlightBullet = function(_param) {
    var color = _param.color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,_object_spread/* default */.Z)({
        css: {
            backgroundColor: color || palette/* lightGreen */.ZE,
            width: 10,
            height: 10,
            display: "inline-block",
            borderRadius: "100%"
        }
    }, props));
};

;// CONCATENATED MODULE: ./components/form/HighlightsInputField.tsx







function HighlightsInputField(param) {
    var fieldName = param.fieldName;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
        name: fieldName,
        children: function(param) {
            var input = param.input;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightsInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
                maxItems: 5,
                characterLimit: 200,
                bulletColor: palette/* primary */.T$,
                inputBorderColor: palette/* primary */.T$,
                style: {
                    backgroundColor: "#FFFFFF"
                }
            }));
        }
    });
};


/***/ }),

/***/ 17463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NumberField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95576);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56225);
/* harmony import */ var _components_form_FieldValidationError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80360);
/* harmony import */ var _govlaunch_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98973);








function NumberField(_param) {
    var label = _param.label, fieldName = _param.fieldName, placeholder = _param.placeholder, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "label",
        "fieldName",
        "placeholder"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_final_form__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
        name: fieldName,
        type: "number",
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                children: [
                    label && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("label", {
                                css: {
                                    fontWeight: 500,
                                    fontSize: 14,
                                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .mediumGray */ .rF,
                                    margin: 0
                                },
                                children: label
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_form_FieldValidationError__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                meta: meta
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_3__/* .Input */ .II, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                        css: {
                            marginTop: label ? 8 : 0,
                            height: 42,
                            width: "100%",
                            borderRadius: 6,
                            outline: 0,
                            border: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .lightestGray */ .v2),
                            fontSize: 14,
                            padding: "6px 12px",
                            "::placeholder": {
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .sealBlue */ .N9
                            },
                            ":focus": {
                                borderColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .primary */ .T$
                            }
                        },
                        placeholder: placeholder
                    }, input, props))
                ]
            });
        }
    });
};


/***/ }),

/***/ 65504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ResourcesField; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-final-form@6.5.9_s44h3cxpdxv6cks4bnqewerqda/node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(56225);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-powerplug@1.0.0_react@17.0.2/node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(41491);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+popover@0.10.2_qlbrybfyutdb3nzvgq5n4v5xcq/node_modules/@govlaunch/popover/index.js + 59 modules
var popover = __webpack_require__(70271);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dotdotdot@1.3.1_oxfzelaz5ynxsop2v2nu2h2m64/node_modules/react-dotdotdot/src/index.js
var src = __webpack_require__(94881);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
;// CONCATENATED MODULE: ./components/form/resources/Resource.tsx






function Resource(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        css: {
            padding: 15,
            display: "flex",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
            borderBottom: "1px solid ".concat(palette/* lightestGray */.v2),
            "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.01)"
            }
        }
    }, props), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./components/form/resources/RemoveResourceButton.tsx



function RemoveResourceButton(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
        css: {
            cursor: "pointer",
            top: "50%",
            transform: "translateY(-50%)",
            right: 2,
            position: "absolute",
            width: 25,
            height: 25,
            lineHeight: "20px",
            color: palette/* red */.Q6,
            fontWeight: 500,
            fontSize: 22,
            border: 0,
            borderRadius: "100%"
        },
        type: "button",
        onClick: onClick,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: {
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)"
            },
            children: "\xd7"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(87169);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
;// CONCATENATED MODULE: ./components/form/resources/ShowMoreButton.tsx







function ShowMoreButton(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        role: "button",
        "aria-label": intl.formatMessage({
            defaultMessage: "Show more",
            id: "aWpBzj"
        }),
        css: {
            cursor: "pointer",
            minHeight: 40,
            textTransform: "uppercase",
            color: palette/* sealBlue */.N9,
            fontSize: 12,
            textAlign: "center",
            "&:hover": {
                color: palette/* darkGray */.O5
            },
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "Show more",
            id: "aWpBzj"
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
;// CONCATENATED MODULE: ./components/icons/DocumentIcon.tsx






function DocumentIcon(_param) {
    var fill = _param.fill, props = (0,_object_without_properties/* default */.Z)(_param, [
        "fill"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 16 22",
        width: 16,
        height: 22
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: fill || palette/* primary */.T$,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M12.643 10H3.357C3.143 10 3 9.8 3 9.5s.143-.5.357-.5h9.286c.214 0 .357.2.357.5s-.143.5-.357.5zM12.643 7H8.357C8.143 7 8 6.8 8 6.5s.143-.5.357-.5h4.286c.214 0 .357.2.357.5s-.143.5-.357.5z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M15.636 22H.364C.145 22 0 21.853 0 21.633v-15.4c0-.073.073-.22.073-.293L5.89.073c.073 0 .218-.073.29-.073h9.455c.219 0 .364.147.364.367v21.266c0 .22-.145.367-.364.367zM.727 21.267h14.546V.733H6.327L.727 6.38v14.887z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M6.611 7H.39C.156 7 0 6.844 0 6.611s.156-.389.389-.389h5.833V.39c0-.233.156-.389.39-.389C6.843 0 7 .156 7 .389V6.61C7 6.844 6.844 7 6.611 7zM12.643 13H3.357C3.143 13 3 12.8 3 12.5s.143-.5.357-.5h9.286c.214 0 .357.2.357.5s-.143.5-.357.5zM12.643 16H3.357C3.143 16 3 15.8 3 15.5s.143-.5.357-.5h9.286c.214 0 .357.2.357.5s-.143.5-.357.5zM12.643 19H3.357C3.143 19 3 18.8 3 18.5s.143-.5.357-.5h9.286c.214 0 .357.2.357.5s-.143.5-.357.5z"
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./components/icons/LinkIcon.tsx
var LinkIcon = __webpack_require__(22143);
// EXTERNAL MODULE: ./lib/hooks/useShowMoreCounter.ts
var useShowMoreCounter = __webpack_require__(87386);
;// CONCATENATED MODULE: ./components/icons/FontIcon.tsx






function FontIcon(_param) {
    var fill = _param.fill, props = (0,_object_without_properties/* default */.Z)(_param, [
        "fill"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 340.111 340.111",
        width: "1em",
        height: "1em"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: fill || palette/* primary */.T$,
                d: "M340.111 76.316V65.175h-47.905v11.141h18.382v187.478h-18.382v11.141h47.905v-11.141h-18.382V76.316z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                fill: fill || palette/* primary */.T$,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M2.067 229.59l56.068-126.615c3.909-8.731 11.03-14.018 20.684-14.018h2.068c9.648 0 16.544 5.286 20.449 14.018l56.07 126.615c1.149 2.528 1.84 4.825 1.84 7.124 0 9.421-7.354 17.004-16.776 17.004-8.272 0-13.788-4.825-17.004-12.18l-10.799-25.275H43.891l-11.26 26.426c-2.988 6.893-8.961 11.029-16.315 11.029C7.121 253.718 0 246.365 0 237.173c0-2.528.918-5.055 2.067-7.583zm99.501-44.579l-22.291-53.082-22.289 53.082h44.58zM176.011 216.951v-.46c0-26.885 20.452-39.294 49.635-39.294 12.41 0 21.373 2.068 30.105 5.056v-2.068c0-14.478-8.963-22.519-26.427-22.519-9.651 0-17.464 1.378-24.128 3.447-2.067.689-3.447.918-5.058.918-8.04 0-14.474-6.204-14.474-14.246 0-6.205 3.905-11.49 9.419-13.559 11.03-4.136 22.981-6.434 39.296-6.434 19.071 0 32.86 5.055 41.593 13.787 9.191 9.191 13.327 22.75 13.327 39.295v56.068c0 9.423-7.583 16.775-17.005 16.775-10.111 0-16.774-7.123-16.774-14.477v-.23c-8.502 9.421-20.224 15.625-37.226 15.625-23.211.002-42.283-13.324-42.283-37.684zm80.197-8.043v-6.204c-5.974-2.757-13.787-4.596-22.289-4.596-14.938 0-24.128 5.975-24.128 17.004v.46c0 9.422 7.813 14.936 19.072 14.936 16.315.001 27.345-8.96 27.345-21.6z"
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/form/resources/Resources.tsx














function Resources(param) {
    var resources = param.resources, onRemove = param.onRemove;
    var ref = (0,useShowMoreCounter/* default */.Z)(resources.length, 4), offset = ref.offset, hasMore = ref.hasMore, showMore = ref.showMore;
    var resourcesSlice = resources.slice(0, offset);
    if (resourcesSlice.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: resourcesSlice.map(function(resource, index) {
                    return(// eslint-disable-next-line
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                        children: [
                            resource.type === "download" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                css: {
                                    fontSize: 14,
                                    color: palette/* darkGray */.O5,
                                    textDecoration: "none",
                                    fontWeight: 500,
                                    lineHeight: 1.2,
                                    wordBreak: "break-word",
                                    "&:hover": {
                                        color: palette/* darkGray */.O5
                                    },
                                    display: "block",
                                    "&:focus, &:visited": {
                                        boxShadow: "none"
                                    }
                                },
                                href: resource.url || "",
                                download: resource.filename,
                                external: "outside-govlaunch",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Resource, {
                                    style: {
                                        paddingRight: 30
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RemoveResourceButton, {
                                            onClick: function(event) {
                                                onRemove(resource);
                                                event.preventDefault();
                                            }
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: {
                                                width: 24
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DocumentIcon, {
                                                width: 24,
                                                height: 24,
                                                style: {
                                                    minWidth: 24,
                                                    minHeight: 24
                                                },
                                                fill: "#28D094"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: {
                                                marginLeft: 10,
                                                display: "flex",
                                                flexDirection: "column"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((src_default()), {
                                                clamp: 2,
                                                children: resource.title
                                            })
                                        })
                                    ]
                                })
                            }),
                            resource.type === "link" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                css: {
                                    fontSize: 14,
                                    color: palette/* darkGray */.O5,
                                    fontWeight: 500,
                                    textDecoration: "none",
                                    lineHeight: 1.2,
                                    wordBreak: "break-word",
                                    "&:hover": {
                                        color: palette/* darkGray */.O5
                                    },
                                    display: "block",
                                    "&:focus, &:visited": {
                                        boxShadow: "none"
                                    }
                                },
                                href: resource.url || "",
                                external: "outside-govlaunch",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Resource, {
                                    style: {
                                        paddingRight: 30
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RemoveResourceButton, {
                                            onClick: function(event) {
                                                onRemove(resource);
                                                event.preventDefault();
                                            }
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkIcon/* default */.Z, {
                                            width: 24,
                                            height: 24,
                                            style: {
                                                minWidth: 24,
                                                minHeight: 24
                                            },
                                            fill: "#28D094"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: {
                                                marginLeft: 10,
                                                display: "flex",
                                                flexDirection: "column"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((src_default()), {
                                                clamp: 2,
                                                children: resource.title
                                            })
                                        })
                                    ]
                                })
                            }),
                            resource.type === "text" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
                                children: function(param) {
                                    var on = param.on, toggle = param.toggle;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(popover/* default */.Z, {
                                        placement: "top",
                                        isOpen: on,
                                        onClickOutside: toggle,
                                        boxStyle: {
                                            boxShadow: "0 5px 30px 0 rgba(34, 35, 40, 0.2)"
                                        },
                                        render: function() {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                css: {
                                                    padding: 15,
                                                    maxWidth: 320,
                                                    wordBreak: "break-all",
                                                    wordWrap: "break-word"
                                                },
                                                children: resource.body
                                            });
                                        },
                                        children: function(param) {
                                            var innerRef = param.innerRef;
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                ref: innerRef,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Resource, {
                                                    onClick: toggle,
                                                    css: {
                                                        paddingRight: 30
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RemoveResourceButton, {
                                                            onClick: function() {
                                                                return onRemove(resource);
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FontIcon, {
                                                            width: 24,
                                                            height: 24,
                                                            style: {
                                                                minWidth: 24,
                                                                minHeight: 24
                                                            },
                                                            fill: "#28D094"
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            css: {
                                                                marginLeft: 10,
                                                                display: "flex",
                                                                flexDirection: "column"
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                css: {
                                                                    fontSize: 14,
                                                                    color: palette/* darkGray */.O5,
                                                                    lineHeight: 1.2,
                                                                    fontWeight: 500,
                                                                    wordBreak: "break-word"
                                                                },
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((src_default()), {
                                                                    clamp: 2,
                                                                    children: resource.title
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            });
                                        }
                                    });
                                }
                            })
                        ]
                    }, index));
                })
            }),
            hasMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMoreButton, {
                onClick: showMore
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
;// CONCATENATED MODULE: ./components/form/resources/ResourceFieldError.tsx



function ResourceFieldError(param) {
    var meta = param.meta;
    var error = meta.error || meta.submitError;
    if (!meta.touched || !error) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
        css: {
            margin: "5px 0 0 0",
            color: palette/* red */.Q6,
            fontSize: 11,
            textTransform: "uppercase"
        },
        children: error
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-textarea-autosize@8.3.4_skqlhrap4das3cz5b6iqdn2lqi/node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js + 3 modules
var react_textarea_autosize_browser_esm = __webpack_require__(69585);
// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
// EXTERNAL MODULE: ./lib/utils/validate.ts
var validate = __webpack_require__(32774);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/src/utils/index.ts
var utils = __webpack_require__(20682);
// EXTERNAL MODULE: ./lib/hooks/useIntlValidationMessages.ts
var useIntlValidationMessages = __webpack_require__(67308);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp.js
var fp = __webpack_require__(56365);
;// CONCATENATED MODULE: ./components/form/resources/ResourcesForm.tsx




















function ResourceForm(param) {
    var onSubmit = param.onSubmit, onClose = param.onClose, _allowLinks = param.allowLinks, allowLinks = _allowLinks === void 0 ? true : _allowLinks, _allowDocuments = param.allowDocuments, allowDocuments = _allowDocuments === void 0 ? true : _allowDocuments, _allowText = param.allowText, allowText = _allowText === void 0 ? false : _allowText;
    var intl = (0,useIntl/* default */.Z)();
    var intlValidationMessages = (0,useIntlValidationMessages/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
        keepDirtyOnReinitialize: true,
        initialValues: {
            type: "link"
        },
        onSubmit: onSubmit,
        validate: function(values) {
            return validateResourceForm(values, intlValidationMessages);
        },
        children: function(param) {
            var handleSubmit = param.handleSubmit, values = param.values;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", {
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        width: 350,
                        padding: 15,
                        marginTop: 10
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                            name: "type",
                            children: function(param) {
                                var input = param.input;
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        display: "flex",
                                        justifyContent: "space-around",
                                        width: 100,
                                        margin: "0 auto"
                                    },
                                    children: [
                                        allowLinks && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                position: "relative",
                                                display: "flex",
                                                cursor: "pointer"
                                            },
                                            onClick: function() {
                                                return input.onChange("link");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkIcon/* default */.Z, {
                                                    width: 24,
                                                    height: 24,
                                                    fill: palette/* primary */.T$
                                                }),
                                                values.type === "link" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        height: 2,
                                                        width: "100%",
                                                        position: "absolute",
                                                        bottom: -4,
                                                        left: 0,
                                                        background: palette/* primary */.T$
                                                    }
                                                })
                                            ]
                                        }),
                                        allowDocuments && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                position: "relative",
                                                display: "flex",
                                                cursor: "pointer"
                                            },
                                            onClick: function() {
                                                return input.onChange("download");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DocumentIcon, {
                                                    width: 24,
                                                    height: 24,
                                                    fill: palette/* primary */.T$
                                                }),
                                                values.type === "download" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        height: 2,
                                                        width: "100%",
                                                        position: "absolute",
                                                        bottom: -4,
                                                        left: 0,
                                                        background: palette/* primary */.T$
                                                    }
                                                })
                                            ]
                                        }),
                                        allowText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                position: "relative",
                                                display: "flex",
                                                cursor: "pointer"
                                            },
                                            onClick: function() {
                                                return input.onChange("text");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FontIcon, {
                                                    width: 24,
                                                    height: 24,
                                                    fill: palette/* primary */.T$
                                                }),
                                                values.type === "text" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        height: 2,
                                                        width: "100%",
                                                        position: "absolute",
                                                        bottom: -4,
                                                        left: 0,
                                                        background: palette/* primary */.T$
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                paddingTop: 15,
                                paddingBottom: 15
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                    name: "title",
                                    children: function(param) {
                                        var input = param.input, meta = param.meta;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,_object_spread/* default */.Z)({
                                                    css: {
                                                        height: 42,
                                                        borderRadius: 5,
                                                        border: "1px solid ".concat(palette/* lightestGray */.v2),
                                                        fontSize: 14,
                                                        padding: "5px 10px",
                                                        width: "100%",
                                                        outline: 0,
                                                        "::placeholder": {
                                                            color: palette/* sealBlue */.N9
                                                        },
                                                        ":focus": {
                                                            borderColor: palette/* primary */.T$
                                                        }
                                                    },
                                                    placeholder: intl.formatMessage({
                                                        defaultMessage: "Title",
                                                        id: "9a9+ww"
                                                    })
                                                }, input)),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourceFieldError, {
                                                    meta: meta
                                                })
                                            ]
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                                    mt: 10,
                                    children: [
                                        values.type === "download" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                            name: "url",
                                            children: function(param) {
                                                var input = param.input, meta = param.meta;
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Filestack */.QZ, {
                                                            onSuccess: function(param) {
                                                                var filesUploaded = param.filesUploaded;
                                                                return input.onChange(filesUploaded[0].url);
                                                            },
                                                            customRender: function(param) {
                                                                var onPick = param.onPick;
                                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                                    color: palette/* primary */.T$,
                                                                    textColor: "#fff",
                                                                    size: "xsmall",
                                                                    onClick: onPick,
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                        defaultMessage: "Upload File",
                                                                        id: "ryDJAn"
                                                                    })
                                                                });
                                                            }
                                                        }),
                                                        input.value && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                            mt: 5,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                                css: {
                                                                    fontSize: 12,
                                                                    color: palette/* primary */.T$
                                                                },
                                                                href: input.value,
                                                                external: "outside-govlaunch",
                                                                children: input.value
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourceFieldError, {
                                                            meta: meta
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        values.type === "link" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                            name: "url",
                                            children: function(param) {
                                                var input = param.input, meta = param.meta;
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                            css: {
                                                                height: 42,
                                                                borderRadius: 5,
                                                                border: "1px solid ".concat(palette/* lightestGray */.v2),
                                                                fontSize: 14,
                                                                padding: "5px 10px",
                                                                width: "100%",
                                                                outline: 0,
                                                                "::placeholder": {
                                                                    color: palette/* sealBlue */.N9
                                                                },
                                                                ":focus": {
                                                                    borderColor: palette/* primary */.T$
                                                                }
                                                            },
                                                            type: "url",
                                                            placeholder: "https://"
                                                        }, input), {
                                                            onBlur: function(event) {
                                                                var url = event.target.value.trim();
                                                                url = (0,utils/* prefixWithHttpIfNecessary */.KI)(url, true) || "";
                                                                input.onChange(url);
                                                            }
                                                        })),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourceFieldError, {
                                                            meta: meta
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        values.type === "text" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                            name: "body",
                                            children: function(param) {
                                                var input = param.input, meta = param.meta;
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_textarea_autosize_browser_esm/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,fp.omit)([
                                                            "onFocus"
                                                        ], input)), {
                                                            minRows: 2,
                                                            css: {
                                                                resize: "none",
                                                                width: "100%",
                                                                outline: 0,
                                                                borderRadius: 5,
                                                                border: "1px solid ".concat(palette/* lightestGray */.v2),
                                                                padding: "5px 10px",
                                                                fontSize: 16,
                                                                "::placeholder": {
                                                                    color: palette/* sealBlue */.N9
                                                                },
                                                                ":focus": {
                                                                    borderColor: palette/* primary */.T$
                                                                }
                                                            },
                                                            placeholder: "Enter text"
                                                        })),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourceFieldError, {
                                                            meta: meta
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                    color: palette/* primary */.T$,
                                    type: "submit",
                                    textColor: "#fff",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Save",
                                        id: "jvo0vs"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        width: 15
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                    color: palette/* primary */.T$,
                                    theme: "secondary",
                                    onClick: onClose,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Cancel",
                                        id: "47FYwb"
                                    })
                                })
                            ]
                        })
                    ]
                })
            });
        }
    });
};
function validateResourceForm(values, validationMessages) {
    if (values.type === "download") {
        return (0,validate/* default */.Z)(es/* object */.Ry().shape({
            title: es/* string */.Z_().required(validationMessages.cantBeBlank),
            url: es/* string */.Z_().url(validationMessages.invalidUrl).required(validationMessages.cantBeBlank)
        }))(values);
    }
    if (values.type === "link") {
        return (0,validate/* default */.Z)(es/* object */.Ry().shape({
            title: es/* string */.Z_().required(validationMessages.cantBeBlank),
            url: es/* string */.Z_().url(validationMessages.invalidUrl).required(validationMessages.cantBeBlank)
        }))(values);
    }
    return (0,validate/* default */.Z)(es/* object */.Ry().shape({
        title: es/* string */.Z_().required(validationMessages.cantBeBlank),
        body: es/* string */.Z_().required(validationMessages.cantBeBlank)
    }))(values);
}

;// CONCATENATED MODULE: ./components/form/ResourcesField.tsx









function ResourcesField(param) {
    var fieldName = param.fieldName;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
        name: fieldName,
        children: function(param) {
            var input = param.input;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Resources, {
                        resources: input.value,
                        onRemove: function(resource) {
                            var nextResources = input.value.filter(function(maybeResource) {
                                return maybeResource !== resource;
                            });
                            input.onChange(nextResources);
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
                        children: function(param) {
                            var isOpen = param.on, toggle = param.toggle;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(popover/* default */.Z, {
                                boxStyle: {
                                    boxShadow: "rgba(34, 35, 40, 0.2) 0px 10px 49px 0px"
                                },
                                onClickOutside: function() {
                                    var filestackIsOpen = document.getElementById("__filestack-picker");
                                    if (!filestackIsOpen) {
                                        toggle();
                                    }
                                },
                                placement: "top",
                                isOpen: isOpen,
                                render: function() {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourceForm, {
                                        onSubmit: function(resource) {
                                            input.onChange(input.value.concat(resource));
                                            toggle();
                                        },
                                        onClose: toggle,
                                        allowText: true
                                    });
                                },
                                children: function(param) {
                                    var innerRef = param.innerRef;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        css: {
                                            color: palette/* primary */.T$,
                                            textTransform: "uppercase",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: 14,
                                            cursor: "pointer",
                                            border: "solid 1px ".concat(palette/* lightestGray */.v2),
                                            minHeight: 40,
                                            "&:hover": {
                                                opacity: 0.8
                                            }
                                        },
                                        ref: innerRef,
                                        role: "button",
                                        onClick: toggle,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Add Resource",
                                            id: "A0sFkU"
                                        })
                                    });
                                }
                            });
                        }
                    })
                ]
            });
        }
    });
};


/***/ }),

/***/ 38011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SocialMediaFields; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/TwitterIcon.js
var TwitterIcon = __webpack_require__(22770);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/LinkedinIcon.js
var LinkedinIcon = __webpack_require__(80022);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/FacebookIcon.js
var FacebookIcon = __webpack_require__(74239);
// EXTERNAL MODULE: ./components/icons/InstagramIcon.tsx
var InstagramIcon = __webpack_require__(3815);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-final-form@6.5.9_s44h3cxpdxv6cks4bnqewerqda/node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(56225);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/src/utils/index.ts
var utils = __webpack_require__(20682);
;// CONCATENATED MODULE: ./components/form/SocialMedialUrlInput.tsx








function SocialMedialUrlInput(_param) {
    var input = _param.input, placeholder = _param.placeholder, onClick = _param.onClick, props = (0,_object_without_properties/* default */.Z)(_param, [
        "input",
        "placeholder",
        "onClick"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Input */.II, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        css: {
            height: 42,
            borderRadius: 5,
            border: "1px solid ".concat(palette/* lightestGray */.v2),
            fontSize: 14,
            padding: "5px 10px",
            width: "100%",
            outline: 0,
            "::placeholder": {
                color: palette/* sealBlue */.N9
            },
            ":focus": {
                borderColor: palette/* primary */.T$
            }
        },
        placeholder: placeholder,
        onClick: onClick
    }, input), {
        onBlur: function(event) {
            var url = event.target.value.trim();
            input.onChange((0,utils/* prefixWithHttpIfNecessary */.KI)(url, true) || "");
        }
    }), props));
};

// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
// EXTERNAL MODULE: ./components/form/FieldValidationError.tsx
var FieldValidationError = __webpack_require__(80360);
;// CONCATENATED MODULE: ./components/form/SocialMediaField.tsx







function SocialMediaField(param) {
    var label = param.label, fieldName = param.fieldName, placeholder = param.placeholder, icon = param.icon;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
        name: fieldName,
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    marginRight: 8
                                },
                                children: icon
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                                css: {
                                    fontWeight: 500,
                                    fontSize: 14,
                                    color: palette/* mediumGray */.rF,
                                    margin: 0,
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: label
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldValidationError/* default */.Z, {
                                meta: meta
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mt: 8,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMedialUrlInput, {
                            placeholder: placeholder,
                            input: input
                        })
                    })
                ]
            });
        }
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
;// CONCATENATED MODULE: ./components/form/SocialMediaFields.tsx








function SocialMediaFields() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            gridRowGap: 16
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMediaField, {
                label: "Twitter",
                fieldName: "socialMedia.twitter",
                placeholder: intl.formatMessage({
                    defaultMessage: "Twitter Profile URL",
                    id: "i2aOtT"
                }),
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwitterIcon/* default */.Z, {
                    size: 18,
                    round: true
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMediaField, {
                label: "LinkedIn",
                fieldName: "socialMedia.linkedin",
                placeholder: intl.formatMessage({
                    defaultMessage: "LinkedIn Profile URL",
                    id: "qQddaW"
                }),
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkedinIcon/* default */.Z, {
                    size: 18,
                    round: true
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMediaField, {
                label: "Facebook",
                fieldName: "socialMedia.facebook",
                placeholder: intl.formatMessage({
                    defaultMessage: "Facebook Profile URL",
                    id: "p8zZUC"
                }),
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FacebookIcon/* default */.Z, {
                    size: 18,
                    round: true
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMediaField, {
                label: "Youtube",
                fieldName: "socialMedia.youtube",
                placeholder: intl.formatMessage({
                    defaultMessage: "YouTube Channel URL",
                    id: "oEbLhQ"
                }),
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(YoutubeIcon, {
                    width: 18,
                    height: 18
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMediaField, {
                label: "Instagram",
                fieldName: "socialMedia.instagram",
                placeholder: intl.formatMessage({
                    defaultMessage: "Instagram URL",
                    id: "UPNlBs"
                }),
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InstagramIcon/* default */.Z, {
                    width: 24,
                    height: 24
                })
            })
        ]
    });
};
var YoutubeIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 461.001 461.001"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M365.257 67.393H95.744C42.866 67.393 0 110.259 0 163.137v134.728c0 52.878 42.866 95.744 95.744 95.744h269.513c52.878 0 95.744-42.866 95.744-95.744V163.137c0-52.878-42.866-95.744-95.744-95.744zm-64.751 169.663l-126.06 60.123c-3.359 1.602-7.239-.847-7.239-4.568V168.607c0-3.774 3.982-6.22 7.348-4.514l126.06 63.881c3.748 1.899 3.683 7.274-.109 9.082z",
            fill: "#f61c0d"
        })
    }));
};


/***/ }),

/***/ 89493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StickyFooter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95576);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);






function StickyFooter(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        css: {
            position: "sticky",
            bottom: 0,
            background: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .white */ .ix,
            border: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .lightestGray */ .v2),
            borderRadius: 5,
            zIndex: 999
        }
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 63259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56225);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95576);
/* harmony import */ var _govlaunch_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98973);
/* harmony import */ var _components_form_FieldValidationError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80360);
/* harmony import */ var _components_form_CharacterLimitIndicator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91922);









function TextField(_param) {
    var fieldName = _param.fieldName, label = _param.label, placeholder = _param.placeholder, characterLimit = _param.characterLimit, showCharacterCount = _param.showCharacterCount, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "fieldName",
        "label",
        "placeholder",
        "characterLimit",
        "showCharacterCount"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_final_form__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
        name: fieldName,
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                children: [
                    label && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("label", {
                                css: {
                                    fontWeight: 500,
                                    fontSize: 14,
                                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .mediumGray */ .rF,
                                    margin: 0
                                },
                                children: label
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_form_FieldValidationError__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                meta: meta
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .II, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        css: {
                            marginTop: label ? 8 : 0,
                            height: 42,
                            borderRadius: 5,
                            border: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .lightestGray */ .v2),
                            fontSize: 14,
                            padding: "6px 12px",
                            width: "100%",
                            outline: 0,
                            "::placeholder": {
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .sealBlue */ .N9
                            },
                            ":focus": {
                                borderColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .primary */ .T$
                            }
                        },
                        maxLength: characterLimit,
                        placeholder: placeholder
                    }, input, props)),
                    characterLimit && showCharacterCount && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginTop: 8
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_form_CharacterLimitIndicator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            maxLength: characterLimit,
                            description: input.value,
                            css: {
                                marginLeft: "auto"
                            }
                        })
                    })
                ]
            });
        }
    });
};


/***/ }),

/***/ 75150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextareaField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95576);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56365);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56225);
/* harmony import */ var react_textarea_autosize__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69585);
/* harmony import */ var _components_form_CharacterLimitIndicator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91922);
/* harmony import */ var _components_form_FieldValidationError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80360);











function TextareaField(_param) {
    var fieldName = _param.fieldName, label = _param.label, placeholder = _param.placeholder, characterLimit = _param.characterLimit, showCharacterCount = _param.showCharacterCount, ariaLabel = _param.ariaLabel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "fieldName",
        "label",
        "placeholder",
        "characterLimit",
        "showCharacterCount",
        "ariaLabel"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
        name: fieldName,
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            label && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("label", {
                                css: {
                                    fontWeight: 500,
                                    fontSize: 14,
                                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .mediumGray */ .rF,
                                    margin: 0
                                },
                                children: label
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_form_FieldValidationError__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                meta: meta
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_textarea_autosize__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        css: {
                            marginTop: label ? 8 : 0,
                            "::placeholder": {
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .sealBlue */ .N9
                            },
                            ":focus": {
                                borderColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .primary */ .T$
                            },
                            fontSize: 14,
                            border: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .lightestGray */ .v2),
                            borderRadius: 5,
                            padding: "10px 10px",
                            width: "100%",
                            outline: 0,
                            resize: "none"
                        },
                        maxLength: characterLimit,
                        minRows: 2,
                        maxRows: 6,
                        "aria-label": ariaLabel || placeholder || "",
                        placeholder: placeholder
                    }, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.omit)([
                        "onFocus"
                    ], input), props), {
                        onKeyDown: function(e) {
                            if (e.key === "Enter") {
                                e.preventDefault();
                            }
                        }
                    })),
                    characterLimit && showCharacterCount && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginTop: 8
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_form_CharacterLimitIndicator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            maxLength: characterLimit,
                            description: input.value,
                            css: {
                                marginLeft: "auto"
                            }
                        })
                    })
                ]
            });
        }
    });
};


/***/ }),

/***/ 50523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UrlField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56225);
/* harmony import */ var _govlaunch_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98973);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95576);
/* harmony import */ var _components_form_FieldValidationError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80360);
/* harmony import */ var _components_spacings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52126);
/* harmony import */ var _govlaunch_web_src_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20682);










function UrlField(param) {
    var label = param.label, fieldName = param.fieldName, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "Type a URL (https://)" : _placeholder;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_final_form__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
        name: fieldName,
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("label", {
                                css: {
                                    fontWeight: 500,
                                    fontSize: 14,
                                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .mediumGray */ .rF,
                                    margin: 0
                                },
                                children: label
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_form_FieldValidationError__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                meta: meta
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_spacings__WEBPACK_IMPORTED_MODULE_4__/* .Margin */ .Zt, {
                        mt: 8,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .II, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            css: {
                                height: 42,
                                borderRadius: 5,
                                border: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .lightestGray */ .v2),
                                fontSize: 14,
                                padding: "6px 12px",
                                width: "100%",
                                outline: 0,
                                "::placeholder": {
                                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .sealBlue */ .N9
                                },
                                ":focus": {
                                    borderColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .primary */ .T$
                                }
                            },
                            placeholder: placeholder
                        }, input), {
                            onBlur: function(event) {
                                var url = event.target.value.trim();
                                url = (0,_govlaunch_web_src_utils__WEBPACK_IMPORTED_MODULE_5__/* .prefixWithHttpIfNecessary */ .KI)(url, true) || "";
                                input.onChange(url);
                            }
                        }))
                    })
                ]
            });
        }
    });
};


/***/ }),

/***/ 5974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95576);






var Section = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        css: {
            borderRadius: 4,
            border: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .lightestGray */ .v2),
            backgroundColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .white */ .ix,
            overflow: "hidden"
        }
    }, props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Section);


/***/ }),

/***/ 32190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);





var SectionBody = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        css: {
            padding: 16,
            display: "grid",
            gridRowGap: 12
        }
    }, props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionBody);


/***/ }),

/***/ 73634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95576);



var SectionHeader = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", {
        css: {
            borderBottom: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__/* .lightestGray */ .v2),
            padding: 16,
            textTransform: "uppercase",
            fontSize: 12,
            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__/* .darkGray */ .O5,
            letterSpacing: 0.5,
            fontWeight: 500
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionHeader);


/***/ }),

/***/ 63615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SectionHeaderMaker; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95576);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _components_icons_DisruptorD__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30283);
/* harmony import */ var _components_icons_MakersIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52105);
/* harmony import */ var _components_spacings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52126);
/* harmony import */ var _components_Tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79313);










function SectionHeaderMaker(_param) {
    var _target = _param.target, target = _target === void 0 ? "MAKERS" : _target, disruptorTooltip = _param.disruptorTooltip, makersTooltip = _param.makersTooltip, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "target",
        "disruptorTooltip",
        "makersTooltip",
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        css: {
            borderBottom: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .lightestGray */ .v2),
            padding: 15,
            textTransform: "uppercase",
            fontSize: 12,
            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .darkGray */ .O5,
            letterSpacing: 0.5,
            fontWeight: 500,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            backgroundColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .white */ .ix
        }
    }, props), {
        children: [
            children,
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_Tooltip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                arrowSize: 6,
                backgroundColor: target === "DISRUPTOR" ? "#9769ea" : _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .disruptiveGreen */ .fx,
                render: function() {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                        css: {
                            padding: 8,
                            fontWeight: "bold",
                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .white */ .ix,
                            fontSize: 14
                        },
                        children: target === "DISRUPTOR" ? disruptorTooltip : makersTooltip
                    });
                },
                children: function(param) {
                    var innerRef = param.innerRef, bind = param.bind;
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_spacings__WEBPACK_IMPORTED_MODULE_3__/* .Margin */ .Zt, {
                        ml: 5,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                            ref: innerRef
                        }, bind), {
                            children: [
                                target === "DISRUPTOR" && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_icons_DisruptorD__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    width: 18,
                                    height: 18
                                }),
                                target === "MAKERS" && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_icons_MakersIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    width: 18,
                                    height: 18
                                })
                            ]
                        }))
                    });
                }
            })
        ]
    }));
};


/***/ }),

/***/ 30283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DisruptorD; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




function DisruptorD(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: 80,
        height: 80,
        viewBox: "0 0 80 80"
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("defs", {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("linearGradient", {
                    x1: "0%",
                    y1: "50%",
                    x2: "156.67%",
                    y2: "50%",
                    id: "sakj4209sa0r",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                            stopColor: "#7962FF",
                            offset: "0%"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                            stopColor: "#E87BB1",
                            offset: "100%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                        d: "M40 0c22.063 0 40 17.937 40 40S62.063 80 40 80 0 62.063 0 40 17.937 0 40 0z",
                        fill: "url(#sakj4209sa0r)"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                        d: "M39.805 55c9.405 0 15.93-5.94 15.93-14.985 0-9.045-6.525-15.03-15.93-15.03H27.97V55h11.835zm0-5.625H34.36V30.61h5.445c6.165 0 9.405 4.095 9.405 9.405 0 5.085-3.465 9.36-9.405 9.36z",
                        fill: "#FFF",
                        fillRule: "nonzero"
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 3815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




var InstagramIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        viewBox: "0 0 551.034 551.034"
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("linearGradient", {
                id: "prefix__a",
                gradientUnits: "userSpaceOnUse",
                x1: 275.517,
                y1: 4.57,
                x2: 275.517,
                y2: 549.72,
                gradientTransform: "matrix(1 0 0 -1 0 554)",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                        offset: 0,
                        stopColor: "#e09b3d"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                        offset: 0.3,
                        stopColor: "#c74c4d"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                        offset: 0.6,
                        stopColor: "#c21975"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                        offset: 1,
                        stopColor: "#7024c4"
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                d: "M386.878 0H164.156C73.64 0 0 73.64 0 164.156v222.722c0 90.516 73.64 164.156 164.156 164.156h222.722c90.516 0 164.156-73.64 164.156-164.156V164.156C551.033 73.64 477.393 0 386.878 0zM495.6 386.878c0 60.045-48.677 108.722-108.722 108.722H164.156c-60.045 0-108.722-48.677-108.722-108.722V164.156c0-60.046 48.677-108.722 108.722-108.722h222.722c60.045 0 108.722 48.676 108.722 108.722v222.722z",
                fill: "url(#prefix__a)"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("linearGradient", {
                id: "prefix__b",
                gradientUnits: "userSpaceOnUse",
                x1: 275.517,
                y1: 4.57,
                x2: 275.517,
                y2: 549.72,
                gradientTransform: "matrix(1 0 0 -1 0 554)",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                        offset: 0,
                        stopColor: "#e09b3d"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                        offset: 0.3,
                        stopColor: "#c74c4d"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                        offset: 0.6,
                        stopColor: "#c21975"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                        offset: 1,
                        stopColor: "#7024c4"
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                d: "M275.517 133C196.933 133 133 196.933 133 275.516s63.933 142.517 142.517 142.517S418.034 354.1 418.034 275.516 354.101 133 275.517 133zm0 229.6c-48.095 0-87.083-38.988-87.083-87.083s38.989-87.083 87.083-87.083c48.095 0 87.083 38.988 87.083 87.083 0 48.094-38.989 87.083-87.083 87.083z",
                fill: "url(#prefix__b)"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("linearGradient", {
                id: "prefix__c",
                gradientUnits: "userSpaceOnUse",
                x1: 418.31,
                y1: 4.57,
                x2: 418.31,
                y2: 549.72,
                gradientTransform: "matrix(1 0 0 -1 0 554)",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                        offset: 0,
                        stopColor: "#e09b3d"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                        offset: 0.3,
                        stopColor: "#c74c4d"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                        offset: 0.6,
                        stopColor: "#c21975"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                        offset: 1,
                        stopColor: "#7024c4"
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("circle", {
                cx: 418.31,
                cy: 134.07,
                r: 34.15,
                fill: "url(#prefix__c)"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (InstagramIcon);


/***/ }),

/***/ 22143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LinkIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95576);






function LinkIcon(_param) {
    var fill = _param.fill, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "fill"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 482.8 482.8",
        width: "1em",
        height: "1em"
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
                fill: fill || _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .primary */ .T$,
                d: "M255.2 209.3c-5.3 5.3-5.3 13.8 0 19.1 21.9 21.9 21.9 57.5 0 79.4l-115 115c-21.9 21.9-57.5 21.9-79.4 0l-17.3-17.3c-21.9-21.9-21.9-57.5 0-79.4l115-115c5.3-5.3 5.3-13.8 0-19.1s-13.8-5.3-19.1 0l-115 115C8.7 322.7 0 343.6 0 365.8c0 22.2 8.6 43.1 24.4 58.8l17.3 17.3c16.2 16.2 37.5 24.3 58.8 24.3s42.6-8.1 58.8-24.3l115-115c32.4-32.4 32.4-85.2 0-117.6-5.2-5.3-13.8-5.3-19.1 0z"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
                fill: fill || _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .primary */ .T$,
                d: "M458.5 58.2l-17.3-17.3c-32.4-32.4-85.2-32.4-117.6 0l-115 115c-32.4 32.4-32.4 85.2 0 117.6 5.3 5.3 13.8 5.3 19.1 0s5.3-13.8 0-19.1c-21.9-21.9-21.9-57.5 0-79.4l115-115c21.9-21.9 57.5-21.9 79.4 0l17.3 17.3c21.9 21.9 21.9 57.5 0 79.4l-115 115c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4l115-115c15.7-15.7 24.4-36.6 24.4-58.8 0-22.2-8.6-43.1-24.3-58.8z"
            })
        ]
    }));
};


/***/ })

}]);